import { GenericCard } from '~src/app/spaces/CardView/GenericCard';
import { Messages } from '~src/codegen/Localize';
import { Workbooks } from '~src/content/resources/Workbooks';
import { ExplorableItemDefinition, ContentTypeFilterClause } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { DataConnectionContentType, WorkbookContentType } from '~src/ts/models/ContentTypes';

import { getGenericDefaultFilters } from './getDefaultFilters';

export const ConnectedWorkbooksInDatasourceDefinition: ExplorableItemDefinition = {
  itemType: 'connectedWorkbook',
  pluralName: Messages.connectedWorkbooks,
  singularName: Messages.connectedWorkbook,
  emptyStateMessage: Messages.connectedWorkbooksEmptyMessage,
  contentFilterKeys: DataConnectionContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['connectedWorkbook']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return Workbooks.all().withExtraParams(WorkbookContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list', 'thumbnail'],
};
